import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Paper, Grid, Typography, Container, Button, Box } from '@mui/material';

import { cancelBillingLink } from '../../actions/user';

const ConsolidatedBilling = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  const handleDeactivate = async () => {
    setLoading(true);
    await dispatch(cancelBillingLink());
  };

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant='h4' component='h2' gutterBottom>
              Your Account Uses Consolidated Billing
            </Typography>
            <Typography variant='h6' gutterBottom>
              Your account is linked to:
            </Typography>
            <Typography variant='h5' gutterBottom>
              {user.billing_account_email}
            </Typography>
            <Box sx={{ my: 2 }}>
              <Typography paragraph>
                If you would like to deactivate consolidated billing, click the
                Deactivate button below.
              </Typography>
              <Typography paragraph>
                This will cause all jobs to stop and your datasets and models to
                be removed if you do not purchase credits after unlinking.
              </Typography>
            </Box>
            <Button
              variant='contained'
              color='error'
              onClick={handleDeactivate}
              disabled={loading}
            >
              {loading ? 'Deactivating...' : 'Deactivate'}
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ConsolidatedBilling;
